import { PDFGenerator, type QuoteData } from "./pdf-generator";

export const DEFAULT_REPORT_FEEDBACK = "Bitte geben Sie uns eine Rückmeldung zu den beschriebenen Schäden, offenen Fragen und erforderlichen Abklärungen. Auf Grundlage Ihrer Antwort können wir die Maßnahmen und das Angebot kalkulieren. Dieser Fassadencheck dient der Dokumentation und ist noch kein kalkuliertes Angebot.";

export interface FacadeReportPhoto {
  id: string;
  title: string;
  description: string;
  preview?: string;
  amount?: number;
  unit?: string;
}

export interface FacadeReportData {
  projectName: string;
  customerName: string;
  address: string;
  description?: string;
  feedback: string;
  photos: FacadeReportPhoto[];
}

/** Deliberately never copies quote positions, prices, totals or payment data. */
export function facadeReportToPDFData(data: FacadeReportData): QuoteData {
  if (!data.photos.length && !data.description?.trim()) {
    throw new Error("Bitte mindestens ein Foto auswählen oder eine Projektbeschreibung eintragen.");
  }
  return {
    documentType: "report",
    projectName: data.projectName,
    customerName: data.customerName,
    customerAddress: data.address,
    quoteDate: new Date().toISOString().slice(0, 10),
    items: [], notes: "", validUntil: "", subtotal: 0, tax: 0, total: 0,
    projectDetails: data.description?.trim() ? { description: data.description } : undefined,
    report: { feedback: data.feedback, photos: data.photos.map((photo) => ({ ...photo })) },
  };
}

export async function generateFacadeReportPDF(data: FacadeReportData): Promise<Blob> {
  return new PDFGenerator().generateQuotePDF(facadeReportToPDFData(data));
}
